import { Component, OnInit, Input } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { AuthenticationService } from 'src/app/service/authentication.service';
import WireTransferDetail from '../../../assets/jsondata/wire-transfer-detail.json';
import { isNullOrUndefined } from 'util';
import { EnvService } from 'src/app/service/env.service';
import { UtilService } from '../../service/util.service';
import { BillingService } from 'src/app/service/billing.service';
import { Constants } from 'src/app/constants/constants';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-invoice-pdf',
  templateUrl: './invoice-pdf.component.html',
  styleUrls: ['./invoice-pdf.component.scss']
})
export class InvoicePdfComponent implements OnInit {

  @Input() invoice;
  isPaymentMethodSet: boolean = false;
  footerMessages: Array<Array<any>> = [];
  // wireTransferDetail: any;

  pageSize: any = {
    width: 595.28,
    height: 841.68
  };
  account: any;

  constructor(public authService: AuthenticationService, private datePipe: DatePipe, private decimalPipe: DecimalPipe,
    private env: EnvService, public utilService: UtilService, private billingService: BillingService) { }

  ngOnInit() {
    // this.wireTransferDetail = WireTransferDetail;
    // this.initFooterMessages();
  }

  async generatePdf() {
    const documentDefinition = await this.prepareDocumentDefinition();
    // var filename = 'Invoice_' + this.invoice.invoiceNumber;
    var filename = 'Nissan_' + this.invoice.invoiceNumber + '_' + 
      this.datePipe.transform(this.invoice.invoiceSummary.billingPeriod.endDate, 'MMyyyy', this.utilService.countryData.timezone) + '.pdf';
    pdfMake.createPdf(documentDefinition).download(filename);
  }

  async prepareDocumentDefinition() {
    var content = [];
    content.push(await this.getInvoiceHeader());
    content.push(this.getCustomerInfoDocument());
    content.push(this.getInvoiceSummary());
    this.invoice.invoiceBreakdown.forEach(pkg => {
      content.push(this.getPackageChargesTable(pkg));
    })

    if(!isNullOrUndefined(this.invoice.customTexts) && this.invoice.customTexts.length > 0) {
      content.push({text: '', style: ['mt30']});
      content.push.apply(content, this.getCustomTextDocument());
    }

    content.push(this.getPaymentInstruction());

    let that = this;
    var documentDef = {
      pageSize: that.pageSize,
      watermark: { text: 'Nissan Connected', color: '#343434', opacity: 0.1, bold: true, italics: false },
      content: content,
      footer: function (currentPage, pageCount) {
        return [
          that.getHorizontalLine(),
          that.getFooterMessage(currentPage)
        ]
      },
      info: {
        title: 'Invoice_' + this.invoice.invoiceNumber,
        author: this.invoice.customerInfo.name,
        subject: 'Invoice',
        keywords: 'Invoice',
      },
      styles: this.getStyles()
    };

    return documentDef;
  }

  getStyles() {
    return {
      //Fonts
      font8: {
        fontSize: 8,
        color: '#4c4c4c'
      },
      font10: {
        fontSize: 8,
        color: '#4c4c4c'
      },
      font13: {
        fontSize: 13,
        color: '#4c4c4c'
      },
      font13Bold: {
        fontSize: 13,
        color: '#4c4c4c',
        bold: true
      },
      font14Bold: {
        fontSize: 14,
        color: '#4c4c4c',
        bold: true
      },
      white: {
        color: '#ffffff'
      },
      bold: {
        bold: true
      },
      greyBackground: {
        fillColor: '#343434'
      },
      //Alignments
      rightAlign: {
        alignment: 'right'
      },
      centerAlign: {
        alignment: 'center'
      },
      leftAlign: {
        alignment: 'left'
      },
      //Margins
      mt5: {
        margin: [0, 5, 0, 0]
      },
      mt10: {
        margin: [0, 10, 0, 0]
      },
      mt20: {
        margin: [0, 20, 0, 0]
      },
      mt30: {
        margin: [0, 30, 0, 0]
      },
      mb10: {
        margin: [0, 0, 0, 10]
      },
      mb20: {
        margin: [0, 0, 0, 20]
      },
      mtb2010: {
        margin: [0, 20, 0, 10]
      },
      footer: {
        fontSize: 10,
        color: '#6c757d',
        margin: [0, 10, 0, 10]
      },
      link: {
        color: '#15c'
      },
    }
  }

  initFooterMessages() {
    this.footerMessages = [];
    let message = [];
    //prepare message
    if (this.isPaymentMethodSet) {
      message.push({ text: 'Payment Instructions: ', bold: true });
      message.push('Please DO NOT PAY. You will be charged the amount due through your selected method of payment.');
    } else {
      message.push('Please set up the payment through ');
      message.push({ text: 'B2B Portal', link: this.env.B2B_URL, style: 'link' });
    }
    this.footerMessages.push(message);
    //reset the message
    message = [];
    //prepare message
    message.push({
      text: [
        'Billing services & queries: Contact Customer Support at ',
        { 
          text: Constants.SUPPORT_LINK, 
          style: 'link', 
          link: `mailto:${Constants.SUPPORT_LINK}`
        },
        // { text: 'B2B Portal', link: this.env.B2B_URL, style: 'link', target: '_blank' },
        ' and access Support\n Nissan Inc., 1 Nissan Way, Franklin, TN 37067, United States'
      ],
      style: ['footer', 'centerAlign', 'font8']
    });
    this.footerMessages.push(message);
    // console.log("footer message::", this.footerMessages);
  }

  async getInvoiceHeader() {
    let invoiceHeader = {
      columns: [
        [
          {
            image: await this.getBase64ImageFromUrl(),
            width: 90,
            style: ['leftAlign']
          }
        ],
        [
          {
            text: 'Invoice',
            style: ['font14Bold', 'rightAlign']
          },
          {
            text: 'Invoice Date: ' + this.datePipe.transform(this.invoice.invoiceDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone),
            style: ['font10', 'rightAlign']
          },
          {
            text: 'Invoice Number: ' + this.invoice.invoiceNumber,
            style: ['font10', 'rightAlign']
          },
          {
            text: 'Invoice Status: ' + this.invoice.invoiceStatus,
            style: ['font10', 'rightAlign']
          },
          {
            text: 'Due Date: ' + this.datePipe.transform(this.invoice.invoiceSummary.dueDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone),
            style: ['font10', 'rightAlign']
          },
          {
            text: this.decimalPipe.transform(this.invoice.invoiceSummary.total, '1.2-2') + " " + this.invoice.invoiceSummary.currency,
            style: ['font14Bold', 'rightAlign']
          }
        ]
      ],
      style: ['mt20']
    };

    if (this.invoice.poNumber) {
      let poNumberObj = {
        text: 'PO #: ' + this.invoice.poNumber,
        style: ['font10', 'rightAlign']
      };
      invoiceHeader.columns[1].splice(3, 0, poNumberObj);
    }

    return invoiceHeader;
  }

  getHorizontalLine() {
    return {
      canvas: [
        {
          type: 'line',
          x1: 10,
          y1: 0,
          x2: this.pageSize.width - 10,
          y2: 0,
          color: '#c8c8c8',
          lineWidth: 0.1
        }
      ]
    }
  }

  getFooterMessage(pageNumber: number) {
    // console.log("footer message::", this.footerMessages);
    var message = [];
    message.push({
      text: [
        'Billing services & queries: Contact Customer Support at ',
        { 
          text: Constants.SUPPORT_LINK, 
          style: 'link', 
          link: `mailto:${Constants.SUPPORT_LINK}`
        },
        // { text: 'B2B Portal', link: this.env.B2B_URL, style: 'link', target: '_blank' },
        ' \n Nissan Inc., 1 Nissan Way, Franklin, TN 37067, United States'
      ],
      style: ['footer', 'centerAlign', 'font8']
    });
    // if (pageNumber == 1) {
    //   message = this.footerMessages[0];
    // } else {
    //   message = this.footerMessages[1];
    // }

    return {
      text: message,
      style: ['footer', 'centerAlign', 'font8']
    }
  }

  getInvoiceSummary() {
    return {
      columns: [
        this.getProductDetailDocument(),
        this.getBillSummaryDocument()
      ],
      columnGap: 10,
      pageBreak: "after"
    }
  }

  getPackageChargesTable(pkg) {
    console.log("package1::", pkg);
    if (pkg.ratePlanType == 'LICENSE_BASED' || pkg.ratePlanType == 'FLAT_RATE' || pkg.ratePlanType == 'PREPAID') {
      return this.getFlatRatePackageChargeTable(pkg);
    } else {
      return this.getServiceWisePackageChargeTable(pkg);
    }
  }

  getFlatRatePackageChargeTable(pkg) {
    console.log("selected package::", pkg);
    var body = [];
    body.push(this.getPackageHeader(pkg));
    body.push(this.getTableHeader(pkg));

    var row = [
      this.getPackageOrServices(pkg),
      /* {
        ol: this.getServiceNames(pkg.serviceLineItems), 
        border: [false, false, false, false],
        style: ['font8']
      }, */
      {
        text: this.getVehicleCount(pkg),
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        text: this.decimalPipe.transform(pkg.units, '1.2-2' , this.env.LOCALE),
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        text:  this.getPackageRate(pkg),
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        text: this.decimalPipe.transform(pkg.subTotal, '1.2-2'),
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        text: this.getDiscountOrRevenueShare(pkg),
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        text: pkg.taxRates != 0 ? this.decimalPipe.transform(pkg.taxRates * 100, '1.0-1') + '%' : 'NA',
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        text: this.getTaxes(pkg.taxRates, pkg.taxes),
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        text: this.decimalPipe.transform(pkg.total, '1.2-2'),
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      }
    ];
    body.push(row);

    var subTotal = [
      {
        text: 'Sub-Total:',
        border: [false, false, false, false],
        colSpan: 7,
        style: ['font10', 'bold', 'leftAlign']
      },
      '',
      '',
      '',
      '',
      '',
      '',
      {
        text: this.getTaxes(pkg.taxRates, pkg.taxes),
        border: [false, false, false, false],
        style: ['font10', 'bold', 'rightAlign']
      },
      {
        text: this.decimalPipe.transform(pkg.total, '1.2-2'),
        border: [false, false, false, false],
        style: ['font10', 'bold', 'rightAlign']
      }
    ]
    body.push(subTotal);

    var table = {
      table: {
        widths: ['18%', '10%', '10%', '10%', '12%', '10%', '10%', '10%', '10%'],
        body: body
      }, 
      style: ['mt30']
    }
    return table;
  }

  getServiceWisePackageChargeTable(pkg) {
    console.log("selected package::", pkg);
    var body = [];
    body.push(this.getPackageHeader(pkg));
    body.push(this.getTableHeader(pkg));
    let isLicenseOrFlatOrPrepaid = this.isLicenseOrFlatOrPrepaid(pkg.ratePlanType);
    pkg.serviceLineItems.forEach((service, index) => {
      var row = this.getServiceWiseChargeRow(service, index, isLicenseOrFlatOrPrepaid);
      body.push(row);
    });

    var subTotal = [
      {
        text: 'Sub-Total:',
        border: [false, false, false, false],
        colSpan: 4,
        style: ['font10', 'bold', 'leftAlign']
      },
      '',
      '',
      '',
      {
        text: this.decimalPipe.transform(pkg.subTotal, '1.2-2'),
        border: [false, false, false, false],
        style: ['font10', 'bold', 'rightAlign']
      },
      {
        text: this.getDiscountOrRevenueShare(pkg),
        border: [false, false, false, false],
        style: ['font10', 'bold', 'rightAlign']
      },
      {
        text: pkg.taxRates != 0 ? this.decimalPipe.transform(pkg.taxRates * 100, '1.0-1') + '%' : 'NA',
        border: [false, false, false, false],
        style: ['font10', 'bold', 'rightAlign']
      },
      {
        text: this.getTaxes(pkg.taxRates, pkg.taxes),
        border: [false, false, false, false],
        style: ['font10', 'bold', 'rightAlign']
      },
      {
        text: this.decimalPipe.transform(pkg.total, '1.2-2'),
        border: [false, false, false, false],
        style: ['font10', 'bold', 'rightAlign']
      }
    ]
    body.push(subTotal);

    var table = {
      table: {
        widths: ['18%', '10%', '10%', '10%', '12%', '10%', '10%', '10%', '10%'],
        body: body
      }, 
      style: ['mt30']
    }
    return table;
  }

  getServiceWiseChargeRow(service, index, isLicenseOrFlatOrPrepaid: boolean) {
    var row = [
      {
        text: (index + 1) + '. ' + service.name,
        border: [false, false, false, false],
        style: ['font10', 'leftAlign']
      },
      {
        text: isLicenseOrFlatOrPrepaid ? this.getVehicleCount(service) : '',
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        text: this.decimalPipe.transform(service.units, '1.2-2' , this.env.LOCALE),
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        text: this.decimalPipe.transform(service.rate, '1.2-2'),
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        text: this.decimalPipe.transform(service.subTotal, '1.2-2'),
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        // text: this.decimalPipe.transform(service.discounts, '1.2-2'),
        text: "-",
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        // text: service.taxRates != 0 ? this.decimalPipe.transform(service.taxRates, '1.2-2') : 'NA',
        text: "-",
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        // text: service.taxes != 0 ? this.decimalPipe.transform(service.taxes, '1.2-2') : 'NA',
        text: "-",
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      },
      {
        text: this.decimalPipe.transform(service.subTotal, '1.2-2'),
        border: [false, false, false, false],
        style: ['font10', 'rightAlign']
      }
    ];
    return row;
  }

  getPackageHeader(pkg) {
    var header = [
      {
        text: this.getPackageName(pkg),
        border: [false, false, false, false],
        colSpan: 5,
        style: ['white', 'bold', 'leftAlign', 'greyBackground']
      },
      '',
      '',
      '',
      '',
      {
        text: 'Service Period: ' + this.datePipe.transform(this.invoice.invoiceSummary.billingPeriod.startDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone) + ' - ' + this.datePipe.transform(this.invoice.invoiceSummary.billingPeriod.endDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone),
        border: [false, false, false, false],
        colSpan: 4,
        style: ['white', 'bold', 'rightAlign', 'greyBackground'],
        noWrap: true
      },
      '',
      '',
      ''
    ];
    return header;
  }

  getPackageName(pkg : any) {
    var name = "";
    if (!this.isLicenseOrFlatOrPrepaid(pkg.ratePlanType)) {
      name = pkg.name;
    }

    if(pkg.appliedAs && pkg.appliedAs != 'PREMIUM') {
      name +=  " (" + pkg.appliedAs + ")";
    }
    return name;
  }

  getTableHeader(packageDetails) {
    var tableHeader = [
      {
        // text: 'Package Service',
        text: (this.isLicenseOrFlatOrPrepaid(packageDetails.ratePlanType)) ? 'Package' : 'Package Service',
        border: [false, false, false, false],
        style: ['mt20', 'font10', 'bold', 'leftAlign']
      },
      {
        text: (this.isLicenseOrFlatOrPrepaid(packageDetails.ratePlanType)) ? 'Vehicles' : '',
        border: [false, false, false, false],
        style: ['mt20', 'font10', 'bold', 'rightAlign']
      },
      {
        text: 'Units',
        border: [false, false, false, false],
        style: ['mt20', 'font10', 'bold', 'rightAlign']
      },
      {
        text: 'Rate',
        border: [false, false, false, false],
        style: ['mt20', 'font10', 'bold', 'rightAlign']
      },
      {
        text: 'Sub-Total',
        border: [false, false, false, false],
        style: ['mt20', 'font10', 'bold', 'rightAlign']
      },
      {
        text: this.getNameDiscountsOrRevenueShare(packageDetails),
        border: [false, false, false, false],
        style: ['mt20', 'font10', 'bold', 'rightAlign']
      },
      {
        text: 'Tax Rates',
        border: [false, false, false, false],
        style: ['mt20', 'font10', 'bold', 'rightAlign']
      },
      {
        text: 'Taxes',
        border: [false, false, false, false],
        style: ['mt20', 'font10', 'bold', 'rightAlign']
      },
      {
        text: 'Total',
        border: [false, false, false, false],
        style: ['mt20', 'font10', 'bold', 'rightAlign']
      }
    ];
    return tableHeader;
  }

  getNameDiscountsOrRevenueShare(packageDetail) {

    if (packageDetail && packageDetail.revenueShare && packageDetail.revenueShare.value)
      return "Revenue Share";
    return "Discounts";
  }

  getDiscountOrRevenueShare(packageDetail) {

    if (packageDetail && packageDetail.revenueShare && packageDetail.revenueShare.value) {
      if (packageDetail.revenueShare.revenueShareType == 'PERCENTAGE') {
        return packageDetail.revenueShare.value + "%";
      } else {
        return this.decimalPipe.transform(packageDetail.revenueShare.value, '1.2-2');
      }
    }
    return packageDetail.discounts != 0 ? this.decimalPipe.transform(packageDetail.discounts, '1.2-2') : '0.00'
  }

  getCustomerInfoDocument() {
    return {
      columns: [
        [
          {
            text: 'Customer Info:',
            style: ['font13Bold', 'mt30']
          },
          {
            text: this.invoice.customerInfo.accountInfo.name,
            style: ['font10']
          },
          this.getCustomerAddress(this.invoice.customerInfo.accountInfo.address)
        ],
        [
          {
            text: 'Billing Info:',
            style: ['font13Bold', 'mt30']
          },
          {
            text: this.invoice.customerInfo.billingInfo.name,
            style: ['font10']
          },
          this.getCustomerAddress(this.invoice.customerInfo.billingInfo.address)
        ],
        [
          {
            text: 'Account Number:',
            style: ['font13Bold', 'mt30', 'rightAlign']
          },
          {
            text: this.invoice.accountNumber,
            style: ['font10', 'rightAlign']
          }
        ]
      ],
      style: ['mt20']
    };
  }

  getProductDetailDocument() {
    return {
      table: {
        widths: ['auto', '*'],
        body: [
          [
            {
              text: 'Product Details',
              colSpan: 2,
              border: [false, false, false, false],
              style: ['white', 'bold', 'greyBackground']
            },
            ''
          ],
          [
            {
              text: 'Products:',
              border: [false, false, false, false],
              style: ['font10', 'mt10']
            },
            {
              text: this.getPackageNames(),
              border: [false, false, false, false],
              style: ['font10', 'rightAlign', 'mt10']
            }
          ],
          [
            {
              text: 'Billing Period:',
              border: [false, false, false, false],
              style: ['font10']
            },
            {
              text: this.datePipe.transform(this.invoice.invoiceSummary.billingPeriod.startDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone) + ' - ' + this.datePipe.transform(this.invoice.invoiceSummary.billingPeriod.endDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone),
              border: [false, false, false, false],
              style: ['font10', 'rightAlign']
            }
          ],
          [
            {
              text: 'Payment Term:',
              border: [false, false, false, false],
              style: ['font10']
            },
            {
              text: 'NET ' + this.invoice.invoiceSummary.paymentTerm,
              border: [false, false, false, false],
              style: ['font10', 'rightAlign']
            }
          ],
          [
            {
              text: 'Due Date:',
              border: [false, false, false, false],
              style: ['font10']
            },
            {
              text: this.datePipe.transform(this.invoice.invoiceSummary.dueDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone),
              border: [false, false, false, false],
              style: ['font10', 'rightAlign']
            }
          ]
        ]
      },
      style: ['mt30']
    }
  }

  getBillSummaryDocument() {
    return {
      table: {
        widths: ['auto', '*'],
        body: [
          [
            {
              text: 'Bill Summary',
              border: [false, false, false, false],
              colSpan: 2,
              style: ['white', 'bold', 'greyBackground']
            },
            ''
          ],
          [
            {
              text: 'Charges:',
              border: [false, false, false, false],
              style: ['font10', 'mt10']
            },
            {
              text: this.decimalPipe.transform(this.invoice.invoiceSummary.subTotal, '1.2-2'),
              border: [false, false, false, false],
              style: ['font10', 'rightAlign', 'mt10']
            }
          ],
          [
            {
              text: 'Discounts:',
              border: [false, false, false, false],
              style: ['font10']
            },
            {
              text: this.decimalPipe.transform(this.invoice.invoiceSummary.discounts, '1.2-2'),
              border: [false, false, false, false],
              style: ['font10', 'rightAlign']
            }
          ],
          [
            {
              text: 'Credits:',
              border: [false, false, false, false],
              style: ['font10']
            },
            {
              text: this.decimalPipe.transform(this.invoice.invoiceSummary.credits, '1.2-2'),
              border: [false, false, false, false],
              style: ['font10', 'rightAlign']
            }
          ],
          [
            {
              text: 'Tax:',
              border: [false, false, false, false],
              style: ['font10']
            },
            {
              text: this.invoice.invoiceSummary.taxes != 0 ? this.decimalPipe.transform(this.invoice.invoiceSummary.taxes, '1.2-2') : 'NA',
              border: [false, false, false, false],
              style: ['font10', 'rightAlign']
            }
          ],
          [
            {
              text: 'Total:',
              border: [false, false, false, false],
              style: ['font10', 'bold']
            },
            {
              text: this.decimalPipe.transform(this.invoice.invoiceSummary.total, '1.2-2'),
              border: [false, false, false, false],
              style: ['font10', 'rightAlign', 'bold']
            }
          ]
        ]
      }, 
      style: ['mt30']
    }
  }

  getPackageNames() {
    var names = "";
    if (this.invoice.invoiceSummary.items && this.invoice.invoiceSummary.items.length > 0) {
      names = this.invoice.invoiceSummary.items[0].name;
      for (let i = 1; i < this.invoice.invoiceSummary.items.length; i++) {
        let pkg = this.invoice.invoiceSummary.items[i];
        names += '\n' + pkg.name;
      }
    }
    return names;
  }

  getServiceNames(services: Array<any>): Array<string> {
    var names = [];
    if (services && services.length > 0) {
      services.forEach(service => {
        names.push(service.name);
      });
    }
    return names;
  }

  getPackageRate(pkg: any) {

    if (pkg.ratePlanType == 'PREPAID' || (pkg.appliedAs && pkg.appliedAs == 'TRIAL')) {
      return 'NA';
    }
    return this.decimalPipe.transform(pkg.rate, '1.2-2');
  }

  getPackageDiscount(pkg: any) {
    if (pkg.ratePlanType == 'PREPAID' || (pkg.appliedAs && pkg.appliedAs == 'TRIAL')) {
      return 'NA';
    }
    return this.decimalPipe.transform(pkg.discounts, '1.2-2');
  }

  getCustomerAddress(addressInfo) {
    var address = "";
    if (addressInfo) {
      if (addressInfo.street) {
        address += addressInfo.street + ", \r";
      }
      if (addressInfo.city) {
        address += addressInfo.city + ", ";
      }
      if (addressInfo.state) {
        address += addressInfo.state + ", \r";
      }
      if (addressInfo.country) {
        address += addressInfo.country + ", ";
      }
      if (addressInfo.zipCode) {
        address += addressInfo.zipCode;
      }
    }

    return {
      text: address,
      style: ['font10']
    }
  }

  getPaymentInstruction() {
    this.account = this.authService.accountData;

    let address;
    if (this.billingService.getIsConexioBankTransferAccountID(this.invoice.accountId)) {
      address = [
        ['Bank Name:', WireTransferDetail[1].bankName],
        ['Address:', WireTransferDetail[1].bankAddress],
        ['Account Name:', WireTransferDetail[1].accountToCredit],
        ['Account Number:', WireTransferDetail[1].accountNumber],
        ['ACH Routing Number:', WireTransferDetail[1].achRoutingNumber],
        ['Wire Transfer Routing Number:', WireTransferDetail[1].wireTransferRoutingNumber]
      ]
    } else {
      address = [
        ['Bank Name:', WireTransferDetail[0].bankName],
        ['Bank Address:', WireTransferDetail[0].bankAddress],
        ['ABA/Routing Number:', WireTransferDetail[0].routingNumber],
        ['SWIFT:', WireTransferDetail[0].swift],
        ['Account to Credit:', WireTransferDetail[0].accountToCredit],
        ['Account Number:', WireTransferDetail[0].accountNumber]
      ];
    }

    var body = [];
    var header = [
      {
        text: this.billingService.wireTransferStatement,
        border: [false, false, false, false],
        colSpan: 2,
        style: ['font13Bold', 'mtb2010', 'centerAlign']
      },
      ''
    ];

    body.push(header);

    address.forEach(line => {
      var row = [
        {
          text: line[0],
          border: [false, false, false, false],
          style: ['font10', 'leftAlign']
        },{
          text: line[1],
          border: [false, false, false, false],
          style: ['font10', 'leftAlign']
        }
      ];
      body.push(row);
    });
    var table = {
      table: {
        body: body
      }, 
      style: ['mt30']
    }
    return table;
  }

  getLogoUrl() {
    var logo = "assets/images/logo/nissan-next-logo-black.png";
    if (this.invoice.logo) {
      // logo = this.invoice.logo;
    }
    return logo;
  }

  async getBase64ImageFromUrl() {
    var url = this.getLogoUrl();
    var res = await fetch(url);
    // console.log("res::", res);
    var blob = await res.blob();
    // console.log("blob::", blob);
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        // console.log("result", reader.result);
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }
  
  getCustomTextDocument() {
    let customTexts = this.invoice.customTexts;
    let rows = [];

    for (let i = 0; i < customTexts.length; i++) {
      const customText = customTexts[i];
      const rowFields = customText.rowFields;
      var row = this.getCustomTextRow(rowFields);
      rows.push(row);
    }

    return rows;
  }

  getCustomTextRow(rowFields: Array<any>) {
    var lines = [];
    // var line = rowFields[0].key + ": " + rowFields[0].value;
    lines.push({text: rowFields[0].key, bold: true});
    lines.push(": " + rowFields[0].value)

    for (let j = 1; j < rowFields.length; j++) {
      // line = line + ",  " + rowFields[j].key + ": " + rowFields[j].value
      lines.push({text: ";   " + rowFields[j].key, bold: true});
      lines.push(": " + rowFields[j].value)
    }

    return {
      text: lines,
      style: ['font10', 'mt5']
    };
  }

  getTaxes(taxRates, taxes) {
    if (taxRates == 0 && taxes == 0) {
      return 'NA';
    } else if (taxRates > 0 && taxes == 0) {
      return '-';
    } else {
      return this.decimalPipe.transform(taxes, '1.2-2');
    }
  }

  getPackageOrServices(pkg: any) {
    let data = {
      border: [false, false, false, false],
      style: ['font8', 'bold']
    };
    
    if (this.isLicenseOrFlatOrPrepaid(pkg.ratePlanType)) {
      data['text'] = pkg.name;
    } else {
      data['ol'] = this.getServiceNames(pkg.serviceLineItems);
    }
    return data;
  }

  isLicenseOrFlatOrPrepaid(packageRatePlanType: string): boolean {
    return packageRatePlanType === 'LICENSE_BASED' ||
      packageRatePlanType === 'FLAT_RATE' ||
      packageRatePlanType === 'PREPAID';
  }
  
  getVehicleCount(pkg: any) {
    if (pkg != null && pkg.vehicleCount) {
      return this.decimalPipe.transform(pkg.vehicleCount, '1.0-0');
    }
    return '-';
  }  
}

